module.exports = __webpack_public_path__ + "static/media/myLgo.4ca75a4e.png";